// Imports ------------------------------------------------------------------->

import {Component, handler} from "../Component";
import {element} from "../CustomElement";

import {Page} from "../flipp-page/Page";
import * as array from "../../utils/array";

import {inject} from "../../services/di";
import {FlyerService} from "../../services/FlyerService";
import {LinkService} from "../../services/LinkService";
import { StorageService } from "../../services/StorageService";
import { CrossBrowseFlyerRunService } from "../../services/CrossBrowseFlyerRunService";

// Private Definitions ------------------------------------------------------->

interface ActionLandingProps {
	flyerIds: number[];
	listFlyerRunIds: number[];
	flyerRunIds: number[];
	flyerTypeIds: number[];
	merchantIds: number[];
	itemIds: number[];
}

// Public Definitions -------------------------------------------------------->

/* Dummy component which acts as the entry point for action route (type="flyer_view". The router
	* renders this component so that we can show some UI while the flyer data is being fetched.
	* Once fetched, we simply redirect the user to the appropriate flyer or the flyer listing page
	*/
@element("flipp-action-landing")
export class ActionLanding extends Component<ActionLandingProps, {}> {
	@handler flyerIds: number[];
	@handler listFlyerRunIds: number[];
	@handler flyerRunIds: number[];
	@handler flyerTypeIds: number[];
	@handler merchantIds: number[];
	@handler itemIds: number[];

	@inject flyerService: FlyerService;
	@inject linkService: LinkService;
	@inject storageService: StorageService;
	@inject crossBrowseFlyerRunService: CrossBrowseFlyerRunService;

	prepare() {
		return this.flyerService.getFlyers().then((flyers) => {
			let flyer;
			if (this.listFlyerRunIds && this.listFlyerRunIds.length > 0) {
				flyer = this.crossBrowseFlyerRunService.init(this.listFlyerRunIds, flyers);
			}
			else {
				flyer = array.find(flyers, (flyer) =>
					this._matches(this.flyerIds, flyer.id) &&
					this._matches(this.flyerRunIds, flyer.flyerRunId) &&
					this._matches(this.flyerTypeIds, flyer.flyerTypeId) &&
					this._matches(this.merchantIds, flyer.merchantId));
			}
			return flyer || "Not found";
		});
	}

	renderLoading() {
		return this._doRender();
	}

	render() {
		return this._doRender();
	}

	onRender() {
		if (typeof this.model === "string") {
			this.linkService.execute(this.linkService.linkTo("listing"), this);
		} else {
			this.linkService.execute(this.linkService.linkTo(this.model, {item_id: this.itemIds}), this);
		}
	}

	private _doRender() {
		return <Page show="flyers">
			<section class="main">
				<div class="loading">
					<div class="spinner"></div>
				</div>
			</section>
		</Page>;
	}

	private _matches = (values: number[], id: number) => {
		return !values || array.contains(values, id);
	}

}
